import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PROJECT_COLORS } from '../models/project.constants';
import { DateHelperService } from './date-helper.service';
import { ProjectSectionService } from './project-section.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectHelperService {
  constructor(
    private readonly projectSectionService: ProjectSectionService,
    private readonly dateHelperService: DateHelperService
  ) {}

  public setSectionsWidth(sections: any[]): void {
    const totalSections: number = sections.length;
    sections.forEach((link: any) => {
      link.width = (100 / totalSections).toFixed(2);
    });
  }

  public processProjectResponse(project: any): any {
    if (project) {
      project.startDate = project.startDate ? this.dateHelperService.fromTimestampToDate(project.startDate) : null;
      project.plannedEndDate = project.plannedEndDate
        ? this.dateHelperService.fromTimestampToDate(project.plannedEndDate)
        : null;
      project.airDate = project.airDate ? this.dateHelperService.fromTimestampToDate(project.airDate) : null;
    }
    return project;
  }

  public formatSubsectionName(subSection: string): string {
    const name: string = subSection
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/(^.)|\s\S/g, (l: string) => l.toUpperCase());
    return name.replace('(', ' (');
  }

  public processSubsections(subsections: any[]): void {
    subsections.forEach((sub: any) => {
      sub.orderNumber = sub.id;
      sub.name = this.formatSubsectionName(sub.subSection);
    });
  }

  public countDays(start: Date, end: Date): number {
    return Math.round((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
  }

  public saveProjectInSessionStorage(project: any): void {
    sessionStorage.setItem('project', JSON.stringify(project));
  }

  public getProjectFromSessionStorage(): any {
    const project: string | null = sessionStorage.getItem('project');
    return project ? JSON.parse(project) : null;
  }

  public getAllColors(): string[] {
    return [...PROJECT_COLORS];
  }
}
